import { fetchApi } from '@/services/api-client';

export const IMMIGRATION_COMPLIANCE_PATH = '/immigration-compliance';
export const ADMIN_IMMIGRATION_COMPLIANCE_PATH = '/admin/immigration-compliance';

export type ImmigrationComplianceUser = {
  id: string;
  email: string;
  fullName: string | null;
  nickname: string | null;
  photoUrl: string;
  /** Students only. */
  gradeLevel: number | null;
  role: string;
};

export type ImmigrationCompliance = {
  userId: string;
  user: ImmigrationComplianceUser | null;
  requiresTracking: boolean;
  visaExpiryDate: string | null;
  workPermitExpiryDate: string | null;
  ninetyDayReportDueDate: string | null;
  visaDaysRemaining: number | null;
  workPermitDaysRemaining: number | null;
  ninetyDayReportDaysRemaining: number | null;
  updatedAt: string;
};

export type UpsertImmigrationComplianceData = {
  requiresTracking: boolean;
  visaExpiryDate?: string | null;
  workPermitExpiryDate?: string | null;
  ninetyDayReportDueDate?: string | null;
};

export type HrComplianceSettings = {
  visaWarnDays: number;
  workPermitWarnDays: number;
  ninetyDayReportWarnDays: number;
};

export const immigrationComplianceApi = {
  getMine: () => fetchApi<ImmigrationCompliance | null>(`${IMMIGRATION_COMPLIANCE_PATH}/me`),

  adminList: (role?: 'staff' | 'student') =>
    fetchApi<ImmigrationCompliance[]>(
      role ? `${ADMIN_IMMIGRATION_COMPLIANCE_PATH}?role=${role}` : ADMIN_IMMIGRATION_COMPLIANCE_PATH
    ),

  adminGetByUser: (userId: string) =>
    fetchApi<ImmigrationCompliance | null>(`${ADMIN_IMMIGRATION_COMPLIANCE_PATH}/by-user/${userId}`),

  adminUpsert: (userId: string, data: UpsertImmigrationComplianceData) =>
    fetchApi<ImmigrationCompliance>(`${ADMIN_IMMIGRATION_COMPLIANCE_PATH}/${userId}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),

  getSettings: () => fetchApi<HrComplianceSettings>(`${ADMIN_IMMIGRATION_COMPLIANCE_PATH}/settings`),

  updateSettings: (data: HrComplianceSettings) =>
    fetchApi<HrComplianceSettings>(`${ADMIN_IMMIGRATION_COMPLIANCE_PATH}/settings`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),
};
